import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import { Datagrid, EditButton, FunctionField, ShowButton, TextField } from "react-admin";
import { checkPermission } from "server/security/utils";

const EmployeeTable = () => {
  const userPermissions = getPermissions();

  const rowSx = rec => {
    if (rec && !rec.isActive) {
      return {
        backgroundColor: "#FCECE8",
        opacity: 0.6,
        borderLeft: "4px solid #e31212",
      };
    }
    return {};
  };

  return (
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
      sx={settings.style.firstExpandIconDatagrid}
      rowSx={rowSx}
    >
      <TextField
        source="firstDegreeNameBgShort"
        label="Научна степен"
      />
      <TextField
        label="Име"
        source="firstName"
        emptyText="-"
      />
      <TextField
        label="Презиме"
        source="secondName"
        emptyText="-"
      />
      <TextField
        label="Фамилия"
        source="lastName"
        emptyText="-"
      />
      <TextField
        label="Имейл"
        source="email"
        emptyText="-"
      />
      <FunctionField render={rec => (!rec?.isActive ? "Неактивен" : "")} />
      {checkPermission(userPermissions, permissions.canUpdateEmployees) && <EditButton />}
      {checkPermission(userPermissions, permissions.canPreviewEmployees) && <ShowButton />}
      {/* <DeleteWithConfirmButton /> */}
    </Datagrid>
  );
};

export default EmployeeTable;
